// Color of the state of the vehicle based on stopped time
//  Verde limón [57, 255, 20]
const STATE_0 = '#2AB710'
// Verde/azul [102, 205, 170]
const STATE_1 = '#056D05'
// azul [0, 191, 255]
const STATE_2 = '#FFD700'
// Violeta[138, 43, 226]
const STATE_3 = '#BD9F02'
//  Rosado [255, 105, 180]
const STATE_4 = '#816C00'
// Amarillo [255, 215, 0]
const STATE_5 = '#FF8000'
// Naranja [255, 69, 0]
const STATE_6 = '#C96500'
// rojo [255, 0, 0]
const STATE_7 = '#FF0000'
// café [139, 69, 19]
const STATE_8 = '#795548'
// negro [0, 0, 0]
const STATE_9 = '#000000'

// Color of the state of the vehicle based on stopped time
const SPEED_0 = '#39FF14'

const colorVehicleState = {
  STATE_0,
  STATE_1,
  STATE_2,
  STATE_3,
  STATE_4,
  STATE_5,
  STATE_6,
  STATE_7,
  STATE_8,
  STATE_9
}

const colorSpeedState = {
  SPEED_0
}

export {
  colorVehicleState,
  colorSpeedState
}



// WEBPACK FOOTER //
// ./src/utils/stateColors.js